import React from 'react';
import { components } from '@seaoil/component-lib';
import EPRForm from './EPRForm';
import { LayoutWithNav } from '../../components/Layout';

const { Auth } = components;

function WorkflowPage() {
  return (
    <Auth.PrivateComponent redirect="/login">
      <LayoutWithNav>
        <EPRForm />
      </LayoutWithNav>
    </Auth.PrivateComponent>
  );
}

export default WorkflowPage;
